// material-ui
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import logoIcon from '../../assets/images/users/mdLogo.png';

// ==============================|| POS / ERP LOGO ICON SVG ||============================== //

export default function LogoIcon({ sx }) {
  const theme = useTheme();
  const { currentCompany } = useSelector((state) => state.company);

  const API_BASE = import.meta.env.VITE_APP_API_URL || '';
  const BASE_URL = API_BASE.replace(/\/api\/?$/, ''); // "/api" hata kar sirf domain rakho

  const logoSrc = currentCompany?.logo_url ? `${BASE_URL}${currentCompany.logo_url}` : logoIcon;

  return (
    // <svg
    //   width="128"
    //   height="128"
    //   viewBox="0 0 128 128"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   {/* Main ERP Panel */}
    //   <rect
    //     x="20"
    //     y="24"
    //     width="88"
    //     height="80"
    //     rx="12"
    //     fill={theme.vars.palette.primary.main}
    //   />

    //   {/* POS Header Bar */}
    //   <rect
    //     x="20"
    //     y="24"
    //     width="88"
    //     height="16"
    //     rx="12"
    //     fill={theme.vars.palette.primary.dark}
    //   />

    //   {/* Left Sidebar */}
    //   <rect
    //     x="26"
    //     y="46"
    //     width="14"
    //     height="46"
    //     rx="4"
    //     fill={theme.vars.palette.primary.light}
    //   />

    //   {/* Dashboard Bars */}
    //   <rect
    //     x="48"
    //     y="62"
    //     width="12"
    //     height="30"
    //     rx="3"
    //     fill={theme.vars.palette.success.main}
    //   />
    //   <rect
    //     x="66"
    //     y="54"
    //     width="12"
    //     height="38"
    //     rx="3"
    //     fill={theme.vars.palette.warning.main}
    //   />
    //   <rect
    //     x="84"
    //     y="68"
    //     width="12"
    //     height="24"
    //     rx="3"
    //     fill={theme.vars.palette.error.main}
    //   />
    // </svg>
    <img
      src={logoSrc}
      alt="Bonded Warehouse Logo"
      onError={(e) => { e.target.onerror = null; e.target.src = logoIcon; }}
      style={{
        width: '34px',
        height: '34px',
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        borderRadius: '8px',
        ...sx
      }}
    />
  );
}